import { Button } from '@xo-union/tk-component-buttons';
import { Img, Picture } from '@xo-union/tk-component-picture';
import { Body2, H4 } from '@xo-union/tk-ui-typography';
import React from 'react';

import styles from './sequencePreview.scss';

export const BlockedStateHeader: React.FC = () => {
  return (
    <div className={styles.blockedHeader}>
      <div>
        <H4>Meet Your Free Wedding Website</H4>
        <Body2>Quickly set it up so guests can start saving the date.</Body2>
      </div>
      <Button as="a" href="/gs/wedding-websites/designs">
        Get Started
      </Button>
    </div>
  );
};

export const BlockedStateBody: React.FC = () => {
  return (
    <>
      <Picture env="production" id="a91b6216-138d-4fad-977d-dd6b63b37e27">
        <Img width={1000} alt="Sample Email, Website, and Mobile Website" />
      </Picture>
    </>
  );
};
